class Tab {
  constructor() {
    this.DOM = {
      buttons: document.querySelectorAll('[data-tab-trigger]'),
      containers: document.querySelectorAll('[data-tab-target]'),
      // links: document.querySelectorAll("a[href*='#']"),
    };
    this.#addEvent();
    this.#init();
  }
  #init() {
    if (document.querySelector('[data-tab-trigger]') != null) {
      this.#transition();
    };
  }
  #addEvent() {
    this.DOM.buttons.forEach((button, i) => {
      button.addEventListener('click', this.#select.bind(this, i));
    });
    window.addEventListener('hashchange', this.#transition.bind(this));
  }
  #transition() {
    const hash = location.hash.slice(1);
    const trigger = document.querySelector(`[data-tab-trigger="${hash}"]`) || this.DOM.buttons[0];
    const target = document.getElementById(hash) || this.DOM.containers[0];
    this.#reset();
    trigger.setAttribute('aria-expanded', 'true');
    target.setAttribute('aria-hidden', 'false');
    if(location.hash) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1);
    }
  }
  #select(i) {
    if (this.DOM.buttons[i].getAttribute('aria-expanded') === 'false') {
      const hash = this.DOM.buttons[i].getAttribute('data-tab-trigger');
      this.#reset();
      history.pushState(null, null, `#${hash}`)
      this.DOM.buttons[i].setAttribute('aria-expanded', 'true');
      this.DOM.containers[i].setAttribute('aria-hidden', 'false');
    }
  }
  #reset() {
    for (const button of this.DOM.buttons) {
      if (button.getAttribute('aria-expanded') === 'true') {
        button.setAttribute('aria-expanded', 'false');
      }
    }
    for (const container of this.DOM.containers) {
      if (container.getAttribute('aria-hidden') === 'false') {
        container.setAttribute('aria-hidden', 'true');
      }
    }
  }
}
export default Tab;